import {
  GET_ARRAY_OF_DASHBOARD,
  GET_JSON_OF_DASHBOARD,
} from "../types/dashboardTypes";

const initialState = {
  arrayData: [],
  jsonData: {},
  message: "",
  message_fr: "",
  status: "",
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ARRAY_OF_DASHBOARD:
      return { ...state, arrayData: action.payload };
    case GET_JSON_OF_DASHBOARD:
      return {
        ...state,
        jsonData: action.payload.risk_profile_data,
        status: action.payload.status,
        message: action.payload.message,
        message_fr: action.payload.message_fr,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
